import React, { Component } from 'react';
import PropTypes from 'prop-types';

import ButtonIcon from './button-icon';
import './css/action-textbox.less';

export default class ActionTextBox extends Component {
    state = {
        value: '',
    };

    onChange = (event) => {
        const { value } = event.target;
        this.setState((state, props) => {
            props.onChange(value);
            return { value };
        });
    };

    onClear = () => {
        const { clearOnClick } = this.props;

        this.setState({ value: '' });
        clearOnClick();
    };

    handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            const { actionOnClick } = this.props;
            actionOnClick();
        }
    };

    render() {
        const {
            actionIcon,
            placeholder,
            clearIcon,
            actionOnClick,
            className,
            focus
        } = this.props;
        const { value } = this.state;
        return (
            <div className="action-textbox-container">
                <div className={`action-textbox ${className}`}>
                    <input
                        ref={(input) => {
                            focus && input && input.focus && input.focus();
                        }}
                        placeholder={placeholder}
                        onChange={this.onChange}
                        value={value}
                        onKeyDown={this.handleKeyDown}
                        aria-label={placeholder}
                    />
                    {clearIcon && (
                        <ButtonIcon
                            buttonClass="clearIcon"
                            icon={clearIcon}
                            onClick={this.onClear}
                            ariaLabel="Clear Text"
                        />
                    )}
                    {actionIcon && (
                        <ButtonIcon
                            buttonClass={`actionIcon ${
                                clearIcon ? 'actionActive' : ''
                            }`}
                            icon={actionIcon}
                            onClick={actionOnClick}
                            ariaLabel="Submit"
                        />
                    )}
                </div>
            </div>
        );
    }
}

ActionTextBox.defaultProps = {
    clearIcon: null,
    placeholder: '',
    className: '',
    clearOnClick: () => {},
    focus: false,
};

ActionTextBox.propTypes = {
    /** icon string, must be a valid icon form icon.less */
    actionIcon: PropTypes.string.isRequired,
    /** clear icon, used the clear input */
    clearIcon: PropTypes.string,
    /** placeholder text */
    placeholder: PropTypes.string,
    /** input onchange */
    onChange: PropTypes.func.isRequired,
    /** clear icon click action, clears input text */
    clearOnClick: PropTypes.func,
    /** icon onclick */
    actionOnClick: PropTypes.func.isRequired,
    /** optional additional style classname */
    className: PropTypes.string,
    /** option if input should be in focus on first mount */
    focus: PropTypes.bool,
};
